import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

export const fetchCoupons = async () => {
  const response = await fetch(`${API_BASE_URL}/Coupon/GetAll`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error("Failed to fetch coupons");
  return response.json();
};

export const fetchCouponById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/Coupon/Get/${id}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error("Failed to fetch coupon");
  return response.json();
};

export const fetchCouponRedemptions = async (id) => {
  const response = await fetch(`${API_BASE_URL}/Coupon/${id}/Redemptions`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error("Failed to fetch redemptions");
  return response.json();
};

export const createCoupon = async (coupon) => {
  const response = await fetch(`${API_BASE_URL}/Coupon/Create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(coupon),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Failed to create coupon");
  }
  return response.json();
};

export const updateCoupon = async (id, coupon) => {
  const response = await fetch(`${API_BASE_URL}/Coupon/Edit/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(coupon),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Failed to update coupon");
  }
};

export const toggleCouponActive = async (id) => {
  const response = await fetch(`${API_BASE_URL}/Coupon/ToggleActive/${id}`, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error("Failed to toggle coupon");
  return response.json();
};
